import { createApp } from "vue";
import vueVimeoPlayer from "vue-vimeo-player";
import Vue3Sanitize from "vue-3-sanitize";
import AppLayout from "./layout/index.vue";
import router from "./router";
import store from "./store";

// Botstrap styles

const app = createApp(AppLayout);
app.use(store);
app.use(router);
app.use(vueVimeoPlayer);
app.use(Vue3Sanitize);
router.isReady().then(() => {
  app.mount("#app");
  // const hash = router.currentRoute._rawValue.hash;
  // const hashEl = document.querySelector(hash);
  // if (hash && hashEl) {
  //   window.scrollTo({
  //     top: hashEl.offsetTop,
  //     behavior: "smooth",
  //   });
  // }
  store.dispatch(
    "purl/setPurlId",
    router.currentRoute._rawValue.params.purlId || "purlId not included"
  );
  store.commit("dom/SET_WINDOW_WIDTH", window.innerWidth);
  window.addEventListener("resize", () =>
    store.commit("dom/SET_WINDOW_WIDTH", window.innerWidth)
  );
});

// Bootstrap JS
import "bootstrap/dist/js/bootstrap.js";
